import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import { Alert } from 'react-bootstrap';

export function Errors({ errors }) {
  return (
    <Alert bsStyle="danger">
      <h4>There were errors in your input that prevented the royalty schedule from saving.</h4>
      <ul>
        {errors.map((error, index) => (
          <li key={index}>{error}</li>
        ))}
      </ul>
    </Alert>
  );
}

Errors.propTypes = {
  errors: PropTypes.arrayOf(PropTypes.string),
};

const mapStateToProps = ({ royaltySchedules }) => ({
  errors: royaltySchedules.errors,
});

export default connect(mapStateToProps)(Errors);
